var map = {
	"./animation.js": 1011,
	"./blur.js": 1012,
	"./borders.js": 1013,
	"./brush.js": 1014,
	"./bulge_pinch.js": 1015,
	"./circle.js": 1016,
	"./clone.js": 1017,
	"./crop.js": 1018,
	"./desaturate.js": 1019,
	"./erase.js": 1020,
	"./fill.js": 1021,
	"./gradient.js": 1022,
	"./grid.js": 1023,
	"./line.js": 1024,
	"./magic_wand.js": 1025,
	"./media.js": 1026,
	"./palette256.js": 1027,
	"./pencil.js": 1028,
	"./pick_color.js": 1029,
	"./rasterize.js": 1030,
	"./rectangle.js": 1031,
	"./select.js": 1032,
	"./selection.js": 191,
	"./sharpen.js": 1033,
	"./text.js": 323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1010;